// extracted by css-extract-rspack-plugin
export default {"label":"VacationDaysInfo_label__UlhbE","days":"VacationDaysInfo_days__rEe6D","info":"VacationDaysInfo_info__5wlZp"};